import * as actions from './slice'

const userUploadStart = {
  eventName: 'userUploadStart',
  onStart: {
    action: actions.reset,
    redux: true
  },
  onSuccess: [{
    action: () => actions.setLoading(true),
    redux: true
  }, {
    action: actions.setTotalUsers,
    redux: true
  }]
}

const userUploadProgress = {
  eventName: 'userUploadProgress',
  subscribeOnInit: true,
  onSuccess: {
    action: actions.setProgress,
    redux: true
  }
}

const userUploadFinished = {
  eventName: 'userUploadFinished',
  subscribeOnInit: true,
  onSuccess: {
    action: actions.setResult,
    redux: true
  },
  onStop: {
    action: () => actions.setLoading(false),
    redux: true
  }
}

export {
  userUploadStart,
  userUploadProgress,
  userUploadFinished
}
